// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";

function SurchargeEligibilityNotice(props) {
  var __className = props.className;
  var __isEligibilityPending = props.isEligibilityPending;
  var eligibilitySurchargeDetails = props.eligibilitySurchargeDetails;
  var isEligibilityPending = __isEligibilityPending !== undefined ? __isEligibilityPending : false;
  var className = __className !== undefined ? __className : "";
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var themeObj = match.themeObj;
  var paymentMethodListValue = Jotai.useAtomValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var surchargeAmount = Core__Option.getOr(Core__Option.map(eligibilitySurchargeDetails, (function (s) {
              return s.displayTotalSurchargeAmount.toString();
            })), "");
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: isEligibilityPending || Core__Option.isSome(eligibilitySurchargeDetails),
              children: React.createElement("div", {
                    className: "w-full " + className
                  }, isEligibilityPending ? React.createElement("div", {
                          "aria-atomic": true,
                          "aria-live": "polite",
                          className: "w-full",
                          role: "status"
                        }, React.createElement("span", {
                              className: "sr-only"
                            }, localeString.paymentDetailsBeingCheckedText), React.createElement("div", {
                              "aria-hidden": true,
                              className: "relative h-2.5 w-[72%] overflow-hidden rounded",
                              style: {
                                backgroundColor: themeObj.borderColor,
                                opacity: "0.75"
                              }
                            }, React.createElement("div", {
                                  className: "absolute inset-0 -translate-x-full animate-[shimmer_1.4s_ease_infinite] bg-gradient-to-r from-transparent via-white/70 to-transparent"
                                }))) : React.createElement("div", {
                          "aria-atomic": true,
                          "aria-live": "polite",
                          className: "flex items-start text-xs",
                          role: "status"
                        }, React.createElement("span", {
                              "aria-hidden": true
                            }, React.createElement(Icon$OrcaPaymentPage.make, {
                                  name: "asterisk",
                                  size: 8,
                                  className: "text-red-600 mr-1 mt-[3px] shrink-0"
                                })), React.createElement("div", {
                              className: "text-left",
                              style: {
                                color: themeObj.colorTextSecondary,
                                lineHeight: "1.45"
                              }
                            }, localeString.surchargeMsgAmountForCard(paymentMethodListValue.currency, surchargeAmount))))
            });
}

var make = SurchargeEligibilityNotice;

export {
  make ,
}
/* jotai Not a pure module */
